<script>
import TourMagList from '@/modules/Tour/Client/List';
import TourListComponent from '@/modules/Tour/Client/List/component.vue';

export default {
  components: {
    TourListComponent,
  },
  data: () => ({
    title: 'Туры',
    module: new TourMagList(),
  }),
  mounted() {
    this.module.init();
  },
};
</script>
<template>
  <TemplateItem
    :title="title"
    :loading="module.loading"
    wrap
  >
    <TourListComponent
      :module="module"
      link="/tour"
    />
  </TemplateItem>
</template>
